import moment from "moment-timezone"

export const getTimeFromString = (timeString) => {
    let hour = parseInt(timeString.split(":")[0]),
      min = parseInt(timeString.split(":")[1]);
    return new Date().setHours(hour, min, 0, 0);
};

export const getDateFromDateTimeString = (dateString, timeString) => {
  // Convert the date string to a moment object and set the time zone to "Europe/London"
  const londonMoment = moment.tz(dateString, 'Europe/London');
  const safariFixTimeString = moment(timeString, 'hh:mm A').format('HH:mm');
  const combinedString = `${londonMoment.format('YYYY')}-${londonMoment.format('MM')}-${londonMoment.format('DD')} ${safariFixTimeString}`;
  console.log('combinedString', combinedString);
  window.moment = moment;
  const isoString = moment.tz(combinedString, 'Europe/London').toISOString();
  return isoString;
}

export const getTimeStringDate = (dateString) => {

  const date = new Date(dateString);

  const options = {
    timeZone: 'Europe/London',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };

  return date.toLocaleTimeString('en-GB', options);
}

export const getDateStringDate = (date) => {
  // Your date and time string
  const londonMoment = moment.tz(date, 'Europe/London');
  // Create a new Date object from the string

  // Extract the date components
  const year = londonMoment.year();
  const month = londonMoment.month() + 1; // Months are zero-indexed, so add 1
  const day = londonMoment.date();

  // Format the date and time components as separate strings
  const dateString = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`;
  return dateString;
}

export const formatDateString = (inputDateString) => {
  const date = new Date(inputDateString);
  
  const options = {
    timeZone: 'Europe/London',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };

  return date.toLocaleString('en-GB', options);
}
  